import type { LeadMagnetSubmitPayload } from "../../core/api-client.js";
import type { SimulationComparaisonFormModel } from "./ui-state.js";

export function mapSimulationComparaisonFormToSubmitPayload(
  form: SimulationComparaisonFormModel,
): LeadMagnetSubmitPayload {
  return {
    email: form.email.trim(),
    firstName: form.firstName.trim() || undefined,
    source: form.source.trim(),
    consent: true,
    honeypot: form.honeypot,
    answers: {
      slug_parameter: form.slugParameter,
      prix_achat: parseNumber(form.prixAchat),
      loyer: parseNumber(form.loyerAnnuel),
      annee_index: 1,
    },
  };
}

function parseNumber(value: string): number | undefined {
  const normalized = value.trim().replaceAll(/\s+/g, "");
  if (!normalized) return undefined;
  const parsed = Number(normalized);
  return Number.isFinite(parsed) ? parsed : undefined;
}
